import { render } from "./web-viewer.html?vue&type=template&id=2e8f4e6c&scoped=true&ts=true"
import script from "./web-viewer.ts?vue&type=script&lang=ts"
export * from "./web-viewer.ts?vue&type=script&lang=ts"

import "./web-viewer.scss?vue&type=style&index=0&id=2e8f4e6c&lang=scss&scoped=true"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8f4e6c"]])

export default __exports__